import React, { useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Addfile from "./Addfile";
import Pricelist from "./Pricelist";
import Header from "./Header";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Header />} />
      <Route path="/admin" element={<Login />} />

      {/* Protected Routes */}
      <Route
        path="/pricelist"
        element={<ProtectedRoute element={Pricelist} />}
      />
      <Route
        path="/add"
        element={<ProtectedRoute element={Addfile} />}
      />
    </Routes>
  );
}

export default App;
